// import React, { BaseSyntheticEvent } from 'react'
import { SelectType, SearchInput } from '..'
import { Container } from './SearchBarStyles'

export default function SearchBar() {


    return (
        <Container>
            <SearchInput />
            <SelectType />

        </Container>

    )
}
